import emoji from 'react-easy-emoji';

export const greeting = {
	username: 'Ikalli',
	title: 'Hello I\'m Ikalli!',
	subTitle: emoji("Majoring in Software👨‍🎓 | Wanna be Full-Stack Developer👨‍💻 | Working Hard, Fully Passionated!🔥 | Future Google Developer❤"),
	role: "Front-End Developer",
	resumeLink: "#",
	// IMPORTANT
	// If you don't want to show this, change view to false. DO NOT DELETE!
	view: true
};

export const socialMediaLinks = {
	// IMPORTANT
	// if you don't have, change value to blank or false!! DO NOT DELETE!
	github: 'https://github.com/Ikalli',
	linkedin: 'https://www.linkedin.com/in/doeon-an-2b8b21164',
	email: 'doeon.ikalli@gmail.com',
	facebook: 'https://www.facebook.com/ikalli.doeon',
	twitter: "",
	instagram: "",
	medium: 'https://medium.com/@andoune0719',
	stackoverflow: ''
};

export const skills = {
	title: emoji("I Can Do ⚡"),
	subTitle: "A FRONT-END DEVELOPER WHO WANTS TO EXPLORE MORE TECHs & BACK-END",
	describeSkills: [
		emoji("✔ Develop responsive web application"),
		emoji("✔ Interesting in PWA(Progressive Web App) and SPA"),
		emoji("✔ Proficient in using Git, good communication skills"),
		emoji("✔ Interesting in TypeScript and designing web using Redux"),
		emoji("✔ Making constant efforts in CS Fundamental(OS, DS, Algorithms)"),
	],
	// IMPORTANT
	// You need to find className for font-awesome icon
	// Go to https://fontawesome.com/ and search icon
	lists: [
		{fontAwesome: "fab fa-html5", text: "HTML5", proficiency: 80},
		{fontAwesome: "fab fa-css3-alt", text: "CSS3", proficiency: 90},
		{fontAwesome: "fab fa-js", text: "JS & TS", proficiency: 80},
		{fontAwesome: "fab fa-sass", text: "Sass", proficiency: 30},
		{fontAwesome: "fab fa-react", text: "React", proficiency: 80},
		{fontAwesome: "fab fa-aws", text: "AWS", proficiency: 20},
	],
	view: true
};

export const experience = {
	title: "Work Experience",
	lists: [
		{
			date: "2018.03~",
			company: "Google",
			role: "Front-End Developer",
		},
		{
			date: "test",
			company: "test",
			role: "test",
		},
		{
			date: "test",
			company: "test",
			role: "test",
		},
		{
			date: "test",
			company: "test",
			role: "test",
		},
		{
			date: "test",
			company: "test",
			role: "test",
		}
	],
	view: false
}

export const openSourceProjects = {
	title: emoji("Open Source Projects 💻"),
	view: true
}

export const projects = {
	title: emoji("Projects 💻"),
	subTitle: "MY AWESOME RESULT",
	lists: [
		{
			title: "Genshin-Impact Simulator",
			desc: "Genshin Impact Gacha, Party, Character Simulator",
      url: "https://lumyjuwon.github.io/genshin/"
		},
	],
	view: true
}

export const achievements = {
	title: emoji("Achievements And Certifications 🏆"),
	subTitle: "subtitle for achievement",
	lists: [
		{
			img: require("./assets/sad-icon.png"),
			alt: "I'm sad..",
			title: "There is no Achievement...😥",
			desc: "I'll try harder!"
		},
		{
			img: require("./assets/sad-icon.png"),
			alt: "I'm sad..",
			title: "There is no Certification...😥",
			desc: "I'll try harder!"
		},
	],
	view: false
};

export const blogs = {
	title: emoji("My Posts 📰"),
	subTitle: "subtitle for posts",
	lists: [
		{
			title: "Leetcode Solutions",
			desc: "Solutions and explanations for Leetcode algorithm problems",
			url: "https://ikalli.tistory.com/category/Leetcode"
		},
		{
			title: "Introduction of TensorFlow",
			desc: "Categorize images of clothes using TensorFlow, python library. Read docs of TensorFlow and wrote codes in Google Colab.",
			url: "https://ikalli.tistory.com/6?category=895084"
		},
		{
			title: "ReactFolio Template 적용하기",
			desc: "React Template + GitHub Pages로 쉽게 포트폴리오 웹사이트를 제작해보자! ReactFolio는 React+TypeScript로 만들어진 오픈소스 포트폴리오 웹사이트 Dark Theme Temaplate입니다.",
			url: "https://velog.io/@ikalli/GitHub-Page-React%EB%A5%BC-%EC%9D%B4%EC%9A%A9%ED%95%9C-%ED%8F%AC%ED%8A%B8%ED%8F%B4%EB%A6%AC%EC%98%A4-%EC%9B%B9%EC%82%AC%EC%9D%B4%ED%8A%B8-%ED%98%B8%EC%8A%A4%ED%8C%85"
		},
		{
			title: "JavaScript Tips",
			desc: "Useful and meaningful JavaScript Tips for understanding concepts of JS",
			url: "https://velog.io/@ikalli/series/javascript"
		},
	],
	view: true
}

export const contactInfo = {
	title: "Get in Touch! 📞",
	subTitle: "REACH OUT TO ME AND DISCUSS WITH ME! IF YOU WANT TO JUST SAY 'HI', FEEL FREE TO EMAIL ME!!",
	introduce: emoji("Wanna be Full-Stack Developer👨‍💻 | Working Hard, Fully Passionated!🔥 | Future Google Developer❤"),
	view: true
}